import { DatePipe, formatDate } from "@angular/common";
import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  FormArray,
} from "@angular/forms";
import { GoogleMap } from "@angular/google-maps";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { SharedService } from "src/app/shared-modules/shared.service";
import { CancellationPolicyComponent } from "../cancellation-policy/cancellation-policy.component";
import { CustomerServiceService } from "../customer-service.service";
import { Socket } from "ngx-socket-io";
import { CommonServices } from "../../common.services";
import { WindowRefService } from "../../window-ref.service";
import { environment } from "src/environments/environment";
import { ModelComponent } from "src/app/shared-modules/model/model/model.component";
import { PriceChangeDailogComponent } from "../price-change-dailog/price-change-dailog.component";
import { LoginComponent } from "src/app/shared-modules/login/login.component";
// import { PriceChangeDailogComponent } from "../price-change-dailog/price-change-dailog.component";

@Component({
  selector: "app-truck-details",
  templateUrl: "./truck-details.component.html",
  styleUrls: ["./truck-details.component.css"],
  providers: [DatePipe], // Add this if not already added
})
export class TruckDetailsComponent implements OnInit {
  billingForm!: FormGroup;
  token: any;
  profileValues: any;
  panel: boolean = true;
  Quotation: boolean = false;
  truckDetails_01: boolean = true;
  quotationForm: boolean = false;
  panel1: boolean = false;
  panel2: boolean = false;
  panel3: boolean = false;
  panelForm: boolean = true;
  panel1form1: boolean = false;
  panel2form1: boolean = false;
  panel3form1: boolean = false;
  selectedTruck: boolean = false;
  alternateSelectedTruck: boolean = false;
  bookingDetailBtn: boolean = true;
  TruckDetailsBtn: boolean = false;
  QuoteDetailsBtn: boolean = false;
  loadDetailsBtn: boolean = false;
  paymentBtn: boolean = false;
  selecteLoadCategory: boolean = false;
  terms: boolean = false;
  editBilling: boolean = true;
  billingEdit: boolean = false;
  profileDetails: any;
  SearchTruckDetails: any;
  alternateTruckDetails: any;
  materialDetails: any;
  loadCategory: any;
  paymentDetails: any;
  totalAmount: any;
  paynowAmt: any;
  loadSelectedCategory: any;
  isGstVerifying: boolean = false;
  isGstVerified: boolean = false;
  gstVerificationData: any = null;
  matDialogref: MatDialogRef<CancellationPolicyComponent> | any;
  matDialogre: MatDialogRef<ModelComponent>;
  downImg: boolean = true;
  checkImg: boolean = false;
  downImg1: boolean = true;
  checkImg1: boolean = false;
  downImg2: boolean = true;
  checkImg2: boolean = false;
  downImg3: boolean = true;
  checkImg3: boolean = false;
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  today: any;
  mapConfigurations: any;
  inititalCoordinates: any;
  coordinatesForm!: FormGroup;
  pickupAutoComplete: any;
  pickupLat: any;
  pickupLong: any;
  dropLat: any;
  dropLong: any;
  pickup_long_name: any = "";
  pickup_short_name: any = "";
  dropAutoComplete: any;
  drop_long_name: any = "";
  drop_short_name: any = "";
  completeDropAddress: any;
  completePickUpAddress: any;
  pickupPlace: any;
  dropPlace: any;
  @ViewChild("pickUpLocationSearchField")
  pickUpLocation: ElementRef | any;
  @ViewChild("dropLocationSearchField")
  dropLocation!: ElementRef;
  truckCategory: any = [];
  truckWeight: any = [];
  searchBtn: boolean = true;
  truckDetails: any;
  truck_details: any;
  quote_details: any;
  @ViewChild(GoogleMap) map: GoogleMap | any;
  selectedTruckDetails: any;
  selectedTruckDetailsIndex: any;
  alternateSelectedTruckDetailsIndex: any;
  loadCategorySelectedindex: any;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  loading: boolean = true;
  pickup_postal_code: any;
  dropoff_postal_code: any;
  tripId: any;
  othersType: boolean = false;
  otherValue: any;
  mapHtml: any;
  mapOptions: any;
  mapGoogle: any;
  directionsService: any;
  directionsRenderer: any;
  googleAddress: any;
  internetHandlingChanrges: any;
  tax: any;
  price: any;
  tax_details: any = [];
  round_amount: any;
  round_payamount: any;
  terms_check: any;
  selectedIndexValue: any;
  alternateIndexValue: any;
  sharedData: any;
  QuoteTruckDetails: any;
  loadDetails: any;
  selected_Actual_Price: any;
  driver_route_id: any;
  alternateTrip_Id: any;
  selected_Truck_Type_Id: any;
  locationError: boolean = false;
  locationsMatch: boolean = false;
  showCloseIconPick = false;
  showCloseIconDrop = false;
  pickup_address: any;
  drop_address: any;
  searchPickupDetails: any = [];
  driver_ref_id: any;
  driver_price: any;
  currentFare: any;
  latestFare: any;
  isModalOpen: boolean = false; // Track modal state
  isBookingLoading: boolean = false;
  selectedHSNCode: string = '';
  stops: number[] = [];

  constructor(
    private router: Router,
    private matDialog: MatDialog,
    private services: CustomerServiceService,
    private formBuilder: FormBuilder,
    private shrdSrvcs: SharedService,
    private snackBar: MatSnackBar,
    private socket: Socket,
    private commonServices: CommonServices,
    private windowRef: WindowRefService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef
  ) {
    this.minDate.setDate(this.minDate.getDate() - 0);
    this.maxDate.setDate(this.maxDate.getDate() + 2);
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this.loadDetails === 'quoteBooked' || this.SearchTruckDetails) {
      $event.returnValue = "Refresh/Reload will cause data loss. Re-payment may be required.";
    }
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    sessionStorage.removeItem("quoteBooked");
    sessionStorage.removeItem("selectedId");
    sessionStorage.removeItem("searchData");
    sessionStorage.removeItem("search_details");
    this.shrdSrvcs.updateSearchDetails(null);
  }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("token");
    if (!this.token) {
      this.router.navigateByUrl("/");
      return;
    }
    this.loadDetails = sessionStorage.getItem("quoteBooked");
    this.shrdSrvcs.currentsearchDetails.subscribe((result: any) => {
      this.generateForms();
      if (!result || !result.searchData) {
        const stored = sessionStorage.getItem("search_details");
        if (stored) {
          try {
            result = JSON.parse(stored);
          } catch (e) { }
        }
      }
      if (result && result.searchData) {
        this.SearchTruckDetails = result.searchData;
        this.GetCategory();
        const formattedDate = this.datePipe.transform(
          this.SearchTruckDetails.date,
          "dd-MM-yyyy"
        );

        const pickupAddr =
          this.SearchTruckDetails.pickupPlace?.formatted_address ||
          this.SearchTruckDetails.completePickUpAddress?.formatted_address ||
          [this.SearchTruckDetails.fromLocation?.from_area_name, this.SearchTruckDetails.fromLocation?.from_city_name, this.SearchTruckDetails.fromLocation?.from_pincode].filter(Boolean).join(", ") ||
          this.SearchTruckDetails.fromLocation?.from_city_name ||
          '';

        const dropAddr =
          this.SearchTruckDetails.dropPlace?.formatted_address ||
          this.SearchTruckDetails.completeDropAddress?.formatted_address ||
          [this.SearchTruckDetails.toLocation?.to_area_name, this.SearchTruckDetails.toLocation?.to_city_name, this.SearchTruckDetails.toLocation?.to_pincode].filter(Boolean).join(", ") ||
          this.SearchTruckDetails.toLocation?.to_city_name ||
          '';

        this.coordinatesForm.controls["from_area_name"].setValue(pickupAddr);
        this.coordinatesForm.controls["to_area_name"].setValue(dropAddr);

        this.coordinatesForm.controls["date"].setValue(
          `${this.SearchTruckDetails.date || ''}`
        );
        this.coordinatesForm.controls["truck_category_name"].setValue(
          `${this.SearchTruckDetails.truck_category || ''}`
        );
        this.pickup_short_name =
          this.SearchTruckDetails.fromLocation?.from_city_name ||
          this.SearchTruckDetails.fromLocation?.from_area_name ||
          '';
        this.pickup_postal_code =
          this.SearchTruckDetails.fromLocation?.from_pincode || '';
        this.pickupLat = this.SearchTruckDetails.fromLocation?.from_lat || this.SearchTruckDetails.selected_route?.fromLocation?.from_lat || this.SearchTruckDetails.from_lat || '';
        this.pickupLong = this.SearchTruckDetails.fromLocation?.from_long || this.SearchTruckDetails.selected_route?.fromLocation?.from_long || this.SearchTruckDetails.from_long || '';
        this.drop_long_name =
          this.SearchTruckDetails.toLocation?.to_area_name || '';
        this.drop_short_name =
          this.SearchTruckDetails.toLocation?.to_city_name ||
          this.SearchTruckDetails.toLocation?.to_area_name ||
          '';
        this.dropoff_postal_code =
          this.SearchTruckDetails.toLocation?.to_pincode || '';
        this.dropLat = this.SearchTruckDetails.toLocation?.to_lat || this.SearchTruckDetails.selected_route?.toLocation?.to_lat || this.SearchTruckDetails.to_lat || '';
        this.dropLong = this.SearchTruckDetails.toLocation?.to_long || this.SearchTruckDetails.selected_route?.toLocation?.to_long || this.SearchTruckDetails.to_long || '';

        try {
          const geoCoder = new google.maps.Geocoder();
          if (this.pickupLat && this.pickupLong) {
            geoCoder.geocode({ location: { lat: +this.pickupLat, lng: +this.pickupLong } }, (results: any, status: any) => {
              if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
                const place = results[0];
                this.pickupPlace = place;
                this.completePickUpAddress = place;
                if (this.SearchTruckDetails) {
                  this.SearchTruckDetails.pickupPlace = place;
                  this.SearchTruckDetails.completePickUpAddress = place;
                }
                if (this.googleAddress) {
                  this.googleAddress.completePickUpAddress = place;
                }
                this.coordinatesForm.controls["from_area_name"].setValue(place.formatted_address);
              }
              this.cdr.detectChanges();
            });
          }

          if (this.dropLat && this.dropLong) {
            geoCoder.geocode({ location: { lat: +this.dropLat, lng: +this.dropLong } }, (results: any, status: any) => {
              if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
                const dropPlace = results[0];
                this.dropPlace = dropPlace;
                this.completeDropAddress = dropPlace;
                if (this.SearchTruckDetails) {
                  this.SearchTruckDetails.dropPlace = dropPlace;
                  this.SearchTruckDetails.completeDropAddress = dropPlace;
                }
                if (this.googleAddress) {
                  this.googleAddress.completeDropAddress = dropPlace;
                }
                this.coordinatesForm.controls["to_area_name"].setValue(dropPlace.formatted_address);
              }
              this.cdr.detectChanges();
            });
          }
        } catch (e: any) {
          console.error("Geocoding failed:", e);
        }

        this.completePickUpAddress =
          this.SearchTruckDetails.completePickUpAddress || { formatted_address: pickupAddr };
        this.completeDropAddress =
          this.SearchTruckDetails.completeDropAddress || { formatted_address: dropAddr };
        this.pickupPlace =
          this.SearchTruckDetails.pickupPlace || { formatted_address: pickupAddr, name: this.pickup_short_name };
        this.dropPlace =
          this.SearchTruckDetails.dropPlace || { formatted_address: dropAddr, name: this.drop_short_name };

        if (!this.SearchTruckDetails.pickupPlace) {
          this.SearchTruckDetails.pickupPlace = this.pickupPlace;
        }
        if (!this.SearchTruckDetails.dropPlace) {
          this.SearchTruckDetails.dropPlace = this.dropPlace;
        }
        if (!this.SearchTruckDetails.completePickUpAddress) {
          this.SearchTruckDetails.completePickUpAddress = this.completePickUpAddress;
        }
        if (!this.SearchTruckDetails.completeDropAddress) {
          this.SearchTruckDetails.completeDropAddress = this.completeDropAddress;
        }

        this.coordinatesForm
          .get("from_area_name")
          ?.valueChanges.subscribe((value) => {
            this.showCloseIconPick = !!value;
            if (!value) {
              this.pickup_long_name = "";
              this.pickup_short_name = "";
              this.pickup_postal_code = "";
              this.pickupLat = "";
              this.pickupLong = "";
              this.completePickUpAddress = null;
              this.pickupPlace = null;
            }
          });
        this.coordinatesForm
          .get("to_area_name")
          ?.valueChanges.subscribe((value) => {
            this.showCloseIconDrop = !!value;
            if (!value) {
              this.drop_long_name = "";
              this.drop_short_name = "";
              this.dropoff_postal_code = "";
              this.dropLat = "";
              this.dropLong = "";
              this.completeDropAddress = null;
              this.dropPlace = null;
            }
          });
        if (this.SearchTruckDetails && this.SearchTruckDetails.truck_category) {
          this.GetTruckWeight();
        }
        this.loading = false;
      } else if (this.loadDetails === "quoteBooked") {
        this.router.navigateByUrl("/truck-details");
      } else {
        this.router.navigateByUrl("/");
      }
      this.loading = false;
    });
    this.addStopField()

    if (this.loadDetails === "quoteBooked") {
      this.shrdSrvcs.sharedData$.subscribe((data: any) => {
        if (!data || Object.keys(data).length === 0) {
          this.router.navigateByUrl("/trips");
          return;
        }
        this.QuoteTruckDetails = data;
        this.stopContactDetails();

        // Initialize Payment View
        this.TruckDetailsBtn = false;
        this.bookingDetailBtn = false;
        this.panelForm = false;
        this.panel1form1 = false;
        this.panel2form1 = false;
        this.panel3 = true;
        this.panel3form1 = true;
        this.paymentBtn = true;
        this.selectedTruck = false;
        this.loadDetailsBtn = false;
        this.QuoteDetailsBtn = false;
        this.SearchTruckDetails = "";

        this.selecteLoadCategory = true;
        this.loadSelectedCategory = this.QuoteTruckDetails.load_type;
        this.billingForm.controls['material'].setValue(this.QuoteTruckDetails.material_type);
        this.terms = true;
        this.getProfileDetails();
        this.GetTaxDetails();
      });


      this.services.GetLoadDetails(this.token).subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.loadCategory = response.body.data;
            let commIndex = this.loadCategory.findIndex((c: any) => c.load_category === 'Commercial');
            if (commIndex !== -1) {
              this.loadCatChange('Commercial', commIndex);
            }
            this.downImg1 = false;
            this.checkImg1 = true;
          }
          this.loading = false;
        },
        (error) => {
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });

          if (error.status != 404) {
            localStorage.clear();
            this.router.navigateByUrl("/");
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          this.loading = false;
          return;
        }
      );
    }
  }

  getPlace() {
    const rawAddress =
      this.SearchTruckDetails?.pickupPlace?.formatted_address ||
      this.SearchTruckDetails?.completePickUpAddress?.formatted_address ||
      this.pickupPlace?.formatted_address ||
      this.completePickUpAddress?.formatted_address ||
      this.QuoteTruckDetails?.from_complete_address ||
      this.SearchTruckDetails?.fromLocation?.from_area_name ||
      this.SearchTruckDetails?.fromLocation?.from_city_name ||
      "";

    if (!rawAddress) return "";
    const addressParts = rawAddress.split(",").map((s: string) => s.trim()).filter(Boolean);
    if (addressParts.length <= 2) {
      return addressParts[0] || rawAddress;
    }
    return addressParts.slice(0, 2).join(", ");
  }

  getAddress() {
    const rawAddress =
      this.SearchTruckDetails?.pickupPlace?.formatted_address ||
      this.SearchTruckDetails?.completePickUpAddress?.formatted_address ||
      this.pickupPlace?.formatted_address ||
      this.completePickUpAddress?.formatted_address ||
      this.QuoteTruckDetails?.from_complete_address ||
      [
        this.SearchTruckDetails?.fromLocation?.from_area_name,
        this.SearchTruckDetails?.fromLocation?.from_city_name,
        this.SearchTruckDetails?.fromLocation?.from_pincode
      ].filter(Boolean).join(", ") ||
      "";

    if (!rawAddress) return "";
    const addressParts = rawAddress.split(",").map((s: string) => s.trim()).filter(Boolean);
    if (addressParts.length <= 1) {
      const pin = this.SearchTruckDetails?.fromLocation?.from_pincode || this.pickup_postal_code || "";
      return pin && !addressParts[0].includes(pin) ? `${addressParts[0]} - ${pin}` : addressParts[0];
    } else if (addressParts.length === 2) {
      return addressParts[1];
    }
    return addressParts.slice(2).join(", ");
  }

  getDropPlace() {
    const rawAddress =
      this.SearchTruckDetails?.dropPlace?.formatted_address ||
      this.SearchTruckDetails?.completeDropAddress?.formatted_address ||
      this.dropPlace?.formatted_address ||
      this.completeDropAddress?.formatted_address ||
      this.QuoteTruckDetails?.to_complete_address ||
      this.SearchTruckDetails?.toLocation?.to_area_name ||
      this.SearchTruckDetails?.toLocation?.to_city_name ||
      "";

    if (!rawAddress) return "";
    const addressParts = rawAddress.split(",").map((s: string) => s.trim()).filter(Boolean);
    if (addressParts.length <= 2) {
      return addressParts[0] || rawAddress;
    }
    return addressParts.slice(0, 2).join(", ");
  }

  getDropAddress() {
    const rawAddress =
      this.SearchTruckDetails?.dropPlace?.formatted_address ||
      this.SearchTruckDetails?.completeDropAddress?.formatted_address ||
      this.dropPlace?.formatted_address ||
      this.completeDropAddress?.formatted_address ||
      this.QuoteTruckDetails?.to_complete_address ||
      [
        this.SearchTruckDetails?.toLocation?.to_area_name,
        this.SearchTruckDetails?.toLocation?.to_city_name,
        this.SearchTruckDetails?.toLocation?.to_pincode
      ].filter(Boolean).join(", ") ||
      "";

    if (!rawAddress) return "";
    const addressParts = rawAddress.split(",").map((s: string) => s.trim()).filter(Boolean);
    if (addressParts.length <= 1) {
      const pin = this.SearchTruckDetails?.toLocation?.to_pincode || this.dropoff_postal_code || "";
      return pin && !addressParts[0].includes(pin) ? `${addressParts[0]} - ${pin}` : addressParts[0];
    } else if (addressParts.length === 2) {
      return addressParts[1];
    }
    return addressParts.slice(2).join(", ");
  }

  generateForms() {
    this.billingForm = this.formBuilder.group({
      username: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[a-zA-Z][a-zA-Z\\s]+$/),
        ]),
      ],
      address_line: ["", Validators.compose([Validators.required])],
      city: ["", Validators.compose([Validators.required])],
      state: ["", Validators.compose([Validators.required])],
      pincode: ["", Validators.compose([Validators.required])],
      gst: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/),
        ]),
      ],
      pickupContact: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],
      pickupMobile: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{10}$"),
        ]),
      ],
      dropupContact: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[a-zA-Z][a-zA-Z\\s]+$/),
        ]),
      ],
      dropupMobile: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{10}$"),
        ]),
      ],
      others: [""],
      material: ["", Validators.compose([Validators.required])],
      check1: ["", Validators.required],
      terms_and_conditions: ["", Validators.compose([Validators.required])],
      insurance_acknowledgement: ["", Validators.required],
    });
    this.today = new Date();
    this.coordinatesForm = this.formBuilder.group({
      from_area_name: new FormControl(
        null,
        Validators.compose([Validators.required])
      ),
      to_area_name: new FormControl(
        null,
        Validators.compose([Validators.required])
      ),
      date: [""],
      truck_category_name: ["", [Validators.required]],
      truck_weight: ["", [Validators.required]],
      stops: this.formBuilder.array([]),
    });
  }

  GoTOBack() {
    if (this.loadDetails === "quoteBooked") {
      if (window.confirm("Go back to trips?\nChanges you made may not be saved.")) {
        sessionStorage.removeItem("quoteBooked");
        this.router.navigate(['/trips']);
      }
      return;
    }

    if (this.panel3form1) {
      // Step 4 -> Step 3
      this.panel3form1 = false;
      this.panel3 = false;
      
      this.panel1form1 = true;
      this.paymentBtn = false;
      this.terms = false;
      
      if (this.Quotation) {
        this.QuoteDetailsBtn = true;
        this.TruckDetailsBtn = false;
      } else {
        this.TruckDetailsBtn = true;
      }
      
      this.downImg3 = true;
      this.checkImg3 = false;
      
      this.downImg1 = true;
      this.checkImg1 = false;
      return;
    }

    if (this.panel1form1) {
      // Step 3 -> Step 2
      this.panel1form1 = false;
      this.panel1 = false;
      
      this.panel2form1 = true;
      
      this.TruckDetailsBtn = false;
      this.QuoteDetailsBtn = false;
      this.loadDetailsBtn = true;
      
      this.downImg1 = true;
      this.checkImg1 = false;
      
      this.downImg2 = true;
      this.checkImg2 = false;
      return;
    }

    if (this.panel2form1) {
      // Step 2 -> Step 1
      this.panel2form1 = false;
      this.panel2 = false;
      
      this.panelForm = true;
      
      this.loadDetailsBtn = false;
      this.bookingDetailBtn = true;

      this.downImg2 = true;
      this.checkImg2 = false;

      this.downImg = true;
      this.checkImg = false;
      return;
    }

    if (window.confirm("Reload site?\nChanges you made may not be saved.")) {
      this.SearchTruckDetails = null;
      this.loadDetails = null;
      sessionStorage.removeItem("quoteBooked");
      sessionStorage.removeItem("selectedId");
      sessionStorage.removeItem("searchData");
      sessionStorage.removeItem("search_details");
      window.location.href = "/";
    }
  }

  numberWith4Decimal(num: any) {
    num = num.toString();
    num = num.slice(0, num.indexOf(".") + 5);
    return num;
  }

  GoToLoadDetailsFromBooking() {
    const pickups = this.coordinatesForm.get("from_area_name")?.value;
    const dropup = this.coordinatesForm.get("to_area_name")?.value;
    if (pickups && dropup && pickups === dropup) {
      this.snackBar.open(
        "Pick-up and Drop-off locations should not be the same",
        "Fail",
        { duration: 5000 }
      );
      return;
    }

    if (!this.pickupLat || !this.pickupLong) {
      this.snackBar.open("Please select correct Pick-up location", "Fail", {
        duration: 4000,
      });
      return;
    }

    if (!this.dropLat || !this.dropLong) {
      this.snackBar.open("Please select correct Drop-off location", "Fail", {
        duration: 4000,
      });
      return;
    }

    this.token = sessionStorage.getItem("token");
    if (this.coordinatesForm.invalid) {
      this.coordinatesForm.markAllAsTouched;
      this.snackBar.open("Please provide all the mandatory fields", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    this.bookingDetailBtn = false;
    this.TruckDetailsBtn = false;
    this.QuoteDetailsBtn = false;
    this.loadDetailsBtn = true;

    this.panelForm = false;
    this.downImg = false;
    this.checkImg = true;

    // Open Load Details (panel2) instead of Truck Details (panel1)
    this.panel2 = true;
    this.panel2form1 = true;

    this.panel1 = false;
    this.panel1form1 = false;

    this.services.GetLoadDetails(this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.loadCategory = response.body.data;
          let commIndex = this.loadCategory.findIndex((c: any) => c.load_category === 'Commercial');
          if (commIndex !== -1) {
            this.loadCatChange('Commercial', commIndex);
          }
        }
      },
      (error) => {
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  SearchTrucksAndShowDetails() {
    // Reset truck selections to ensure old selections are not carried over to new search results
    this.selectedTruck = false;
    this.selectedTruckDetails = null;
    this.selectedTruckDetailsIndex = null;
    this.alternateSelectedTruck = false;
    this.alternateTruckDetails = null;
    this.alternateSelectedTruckDetailsIndex = null;
    this.selectedIndexValue = null;
    this.alternateIndexValue = null;

    if (
      !this.loadSelectedCategory ||
      this.billingForm.value.material === ""
    ) {
      this.snackBar.open("Please select material", "Fail", {
        duration: 5000,
      });
      return;
    }

    this.loading = true;
    this.token = sessionStorage.getItem("token");

    // Prepare Data for Search
    let data: any = {
      fromLocation: {
        from_area_name: this.SearchTruckDetails.fromLocation.from_area_name,
        from_city_name: this.pickup_short_name,
        from_lat: (Math.round(this.pickupLat * 10000) / 10000).toString(),
        from_long: (Math.round(this.pickupLong * 10000) / 10000).toString(),
        from_pincode: parseInt(this.pickup_postal_code, 10) || 0,
      },
      from_complete_address: this.completePickUpAddress.formatted_address,
      to_complete_address: this.completeDropAddress.formatted_address,
      toLocation: {
        to_area_name: this.drop_long_name,
        to_city_name: this.drop_short_name,
        to_lat: (Math.round(this.dropLat * 10000) / 10000).toString(),
        to_long: (Math.round(this.dropLong * 10000) / 10000).toString(),
        to_pincode: parseInt(this.dropoff_postal_code, 10) || 0,
      },
      date: this.coordinatesForm?.value?.date,
      truck_category: this.coordinatesForm.value.truck_category_name,
      truck_type: this.coordinatesForm.value.truck_weight,
    };

    const stopsArray = this.stopsArray.value;
    if (stopsArray && stopsArray.length > 0) {
      const validStops = stopsArray.filter((stop: any) => {
        const lat = Number(stop.lat);
        const lng = Number(stop.lng);
        return !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0;
      });
      if (validStops.length > 0) {
        data["stops"] = validStops.map((stop: any) => ({
          area_name: stop.area_name?.trim() || "",
          city_name: stop.city_name?.trim() || "",
          lat: Number(stop.lat).toFixed(4),
          lng: Number(stop.lng).toFixed(4),
          pincode: parseInt(stop.pincode, 10) || 0,
          complete_address: stop.complete_address?.trim() || stop.address?.trim() || "",
        }));

        // DIRECTLY CALL FIND EXACT TRUCK IF STOPS ARE PRESENT
        let tripData: any = {
          from_complete_address: data.from_complete_address,
          pickup_details: data.fromLocation,
          to_complete_address: data.to_complete_address,
          dropoff_details: data.toLocation,
          pickup_date: data.date,
          truck_category: data.truck_category,
          truck_type: data.truck_type || this.selected_Truck_Type_Id,
          load_type: this.loadSelectedCategory,
          material_type:
            this.billingForm.value.others !== ""
              ? this.billingForm.value.material +
              "-" +
              this.billingForm.value.others
              : this.billingForm.value.material,
          hsn_code: this.selectedHSNCode,
          stops: data["stops"]
        };

        this.services.findExactTruck(tripData, this.token).subscribe(
          (response: any) => {
            this.snackBar.open(
              "Quote created for your order.",
              "success",
              {
                duration: 3000,
              }
            ).afterDismissed().subscribe(() => {
              this.router.navigateByUrl("/trips");
            });
          },
          (error: any) => {
            this.snackBar.open(error?.error?.message || "Failed to create quote", "Fail", {
              duration: 5000,
            });
            this.loading = false;
          }
        );
        // this.loading = false; // logic handled asynchronously by subscribe
        return;
      }
    }

    this.services.tripSearchBestRoute(data, this.token).subscribe(
      (response: any) => {
        console.log("response.body. indisdeeee otherTruckType", response.body)

        if (
          response.body.data.length === 0 &&
          response.body.otherTruckType.length === 0
        ) {
          let tripData: any = {
            from_complete_address: data.from_complete_address,
            pickup_details: data.fromLocation,
            to_complete_address: data.to_complete_address,
            dropoff_details: data.toLocation,
            pickup_date: data.date,
            truck_category: data.truck_category,
            truck_type: data.truck_type || this.selected_Truck_Type_Id,
            // Include Load Details for Quote
            load_type: this.loadSelectedCategory,
            material_type:
              this.billingForm.value.others !== ""
                ? this.billingForm.value.material +
                "-" +
                this.billingForm.value.others
                : this.billingForm.value.material,
            hsn_code: this.selectedHSNCode,
          };
          if (stopsArray && stopsArray.length > 0) {
            const validStops = stopsArray.filter((stop: any) => {
              const lat = Number(stop.lat);
              const lng = Number(stop.lng);
              return !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0;
            });
            if (validStops.length > 0) {
              tripData["stops"] = validStops.map((stop: any) => ({
                area_name: stop.area_name?.trim() || "",
                city_name: stop.city_name?.trim() || "",
                lat: Number(stop.lat).toFixed(4),
                lng: Number(stop.lng).toFixed(4),
                pincode: parseInt(stop.pincode, 10) || 0,
                complete_address: stop.complete_address?.trim() || stop.address?.trim() || "",
              }));
            }
          }
          this.services.findExactTruck(tripData, this.token)
            .subscribe((response: any) => {
            });

          this.Quotation = false;
          this.TruckDetailsBtn = false;
          this.loadDetailsBtn = false;
          this.loading = true;
          this.snackBar.open(
            "Quote received! Arranging a suitable truck for you.",
            "Ok",
            {
              duration: 3000,
            }
          ).afterDismissed().subscribe(() => {
            this.router.navigateByUrl("/trips");
          });
          this.loading = false;
          return;
        }

        // Switch to Truck Details Pane
        this.loadDetailsBtn = false;
        this.panel2form1 = false;

        this.panel1 = true;
        this.panel1form1 = true;
        this.downImg1 = true; // reset arrow
        this.checkImg1 = false;

        // Mark Load Details as checked
        this.downImg2 = false;
        this.checkImg2 = true;

        if (response.body.data.length <= 0) {
          this.truckDetails_01 = false;
          this.TruckDetailsBtn = false;
          this.Quotation = true;
          this.QuoteDetailsBtn = true;
          this.quote_details = response.body.otherTruckType;
          this.loading = false;
          return;
        }
        if (response.body.data.length > 0) {
          this.truckDetails_01 = true;
          this.Quotation = false;
          this.TruckDetailsBtn = true;
          this.truck_details = response.body.data;
          data["truckweight"] = this.truckWeight.find((ele: any) => {
            return ele._id === this.coordinatesForm.value?.truck_weight;
          });
          data["truckDetails"] = this.truckDetails;
          data["truckCategory"] = {
            id: this.coordinatesForm.value?.truck_category_name,
            name: this.truckCategory.find((ele: any) => {
              if (ele._id === this.coordinatesForm.value?.truck_category_name) {
                return ele?.truck_category_name;
              }
            }),
          };
          this.loading = false;
        }
      },
      (error) => {
        if (error.status == 401 || 403) {
          localStorage.clear();
          this.router.navigateByUrl("/");
        }
        if (error.error.message === "jwt malformed || jwt expired") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
        this.loading = false;
      }
    );
  }

  get stopsArray(): FormArray {
    return this.coordinatesForm.get('stops') as FormArray;
  }
  addStopField() {
    this.stopsArray.push(
      this.formBuilder.group({
        address: [''],
        lat: [null],
        lng: [null],
        area_name: [''],
        city_name: [''],
        pincode: [null],
        complete_address: [''],
      })
    );
  }

  initStopAutocomplete(element: any, index: number) {
    const autocomplete = new google.maps.places.Autocomplete(element, {
      componentRestrictions: { country: 'in' },
      fields: ['formatted_address', 'geometry'],
    });
    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (place?.geometry?.location) {
        const address = place.formatted_address || '';
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        const geoCoder = new google.maps.Geocoder();
        geoCoder.geocode({ location: { lat, lng } }, (results: any, status: any) => {
          if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
            const components = results[0].address_components;
            let area_name = '';
            let city_name = '';
            let pincode = 0;
            console.log("components", components)
            for (let comp of components) {
              // area_name = sublocality or neighborhood
              if (
                comp.types.includes('sublocality_level_1') ||
                comp.types.includes('neighborhood') ||
                comp.types.includes('sublocality')
              ) {
                area_name = comp.long_name;
              }
              // city_name = locality (actual city name)
              if (comp.types.includes('locality')) {
                city_name = comp.long_name;
              }
              // pincode
              if (comp.types.includes('postal_code')) {
                pincode = parseInt(comp.long_name, 10);
              }
            }
            // If no area found, fallback to city name
            if (!area_name && city_name) {
              area_name = city_name;
            }
            console.log("place.formatted_address", place.formatted_address)
            // Patch values into FormArray
            this.stopsArray.at(index).patchValue({
              address,
              lat: lat.toFixed(4),
              lng: lng.toFixed(4),
              area_name,
              city_name,
              pincode,
              complete_address: place.formatted_address || results[0].formatted_address || address,
            });
            this.reverseGeoCodeStop(geoCoder, { lat, lng }, index);
            this.addStopField()
          }
        });
      } else {
        console.warn('Autocomplete returned place with no geometry:', place);
      }
    });
    this.directionService(this.directionsService, this.directionsRenderer);
  }

  reverseGeoCodeStop(geoCoder: any, latlong: any, index: number) {
    geoCoder.geocode({ location: latlong }, (result: any, status: any) => {
      if (status === google.maps.GeocoderStatus.OK && result.length > 0) {
        const components = result[0].address_components;
        let area_name = '';
        let city_name = '';
        let pincode = 0;
        for (let comp of components) {
          if (
            comp.types.includes('sublocality_level_1') ||
            comp.types.includes('neighborhood') ||
            comp.types.includes('sublocality')
          ) {
            area_name = comp.long_name;
          }
          if (comp.types.includes('locality')) {
            city_name = comp.long_name;
          }
          if (comp.types.includes('postal_code')) {
            pincode = parseInt(comp.long_name, 10);
          }
        }
        // Always overwrite with full formatted address from reverse geocode
        const fullFormatted = result[0].formatted_address;
        this.stopsArray.at(index).patchValue({
          area_name,
          city_name,
          pincode,
          complete_address: fullFormatted, // Overwrite here
        });
      }
    });
  }

  moveStopUp(index: number): void {
    if (index === 0) return;
    const stops = this.stopsArray;
    const current = stops.at(index);
    const prev = stops.at(index - 1);
    stops.setControl(index, prev);
    stops.setControl(index - 1, current);
  }

  moveStopDown(index: number): void {
    if (index === this.stopsArray.length - 1) return;
    const stops = this.stopsArray;
    const current = stops.at(index);
    const next = stops.at(index + 1);
    stops.setControl(index, next);
    stops.setControl(index + 1, current);
  }

  removeStopField(index: number): void {
    this.stopsArray.removeAt(index);
  }

  GetTripBookingId(data: any) {
    if (this.isBookingLoading) return;
    this.isBookingLoading = true;
    if (this.alternateSelectedTruck == true) {
      data.truck_type = "";
      this.selected_Truck_Type_Id = this.alternateTruckDetails?.truck_type_id;
    }
    if (this.selectedTruck == true) {
      data.truck_type = "";
      this.selected_Truck_Type_Id = this.selectedTruckDetails?.truck_type_id;
    }
    let id = sessionStorage.getItem("selectedId");
    let tripData = {
      from_complete_address: data.from_complete_address,
      pickup_details: data.fromLocation,
      to_complete_address: data.to_complete_address,
      dropoff_details: data.toLocation,
      pickup_date: data.date,
      truck_category: data.truck_category,
      truck_type: data.truck_type || this.selected_Truck_Type_Id,
      driver_ref_id: data.driver_ref_id,
      dro_id: data.dro_id,
      load_type: this.loadSelectedCategory,
      material_type:
        this.billingForm.value.others !== ""
          ? this.billingForm.value.material +
          "-" +
          this.billingForm.value.others
          : this.billingForm.value.material,
      hsn_code: this.selectedHSNCode,
    };
    this.services.TripBookingGetId(tripData, this.token).subscribe(
      (response: any) => {
        if (response.status !== 201) {
          this.isBookingLoading = false;
        }
        if (response.status === 201) {
          // Check if driverRoutes.price is different from this.driver_price
          // if (response.body.data.driverRoutes?.price !== this.driver_price) {
          //   this.isModalOpen = true; // Disable button when modal opens
          //   const dialogRef = this.matDialog.open(PriceChangeDailogComponent, {
          //     width: "400px",
          //     disableClose: true,
          //   });
          //   dialogRef.afterClosed().subscribe((result) => {
          //     this.isModalOpen = false; // Disable button when modal opens
          //     if (result) {
          //       this.GoToTruckDetails();
          //       // Continue with the process
          //     } else {
          //       this.GoToTruckDetails();
          //       // Handle the case where the user cancels
          //     }
          //   });
          // }
          this.tripId = response.body.data._id;
          sessionStorage.setItem("selectedId", this.tripId);
        }
      },
      (error) => {
        this.isBookingLoading = false;
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });

        // remove 
        // if (error.status === 406) {
        //   this.snackBar.open(error.error.message, "Fail", {
        //     duration: 5000,
        //   });
        //   this.GoToTruckDetails();
        //   return; // stop further redirects
        // }

        if (error.status != 404) {
          localStorage.clear();
          this.router.navigateByUrl("/");
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        return;
      }
    );
  }

  GoToLoadDetails() {
    // Deprecated/Removed functionality. 
    // This used to navigate Truck -> Load. 
    // Now replaced by HandlePayments which checks truck and goes Truck -> Billing.
  }

  GoToalternateLoadDetails() {
    this.token = sessionStorage.getItem("token");
    if (this.alternateSelectedTruck === false) {
      this.snackBar.open("Please select truck details", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    this.QuoteDetailsBtn = false;
    this.panel1form1 = false;
    this.panel2 = true;
    this.panel2form1 = true;
    this.alternateSelectedTruck = true;
    this.loadDetailsBtn = true;
    this.services.GetLoadDetails(this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.loadCategory = response.body.data;
          let commIndex = this.loadCategory.findIndex((c: any) => c.load_category === 'Commercial');
          if (commIndex !== -1) {
            this.loadCatChange('Commercial', commIndex);
          }
          this.downImg1 = false;
          this.checkImg1 = true;
          this.loading = false;
        }
      },
      (error) => {
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });

        if (error.status != 404) {
          localStorage.clear();
          this.router.navigateByUrl("/");
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        this.loading = false;
        return;
      }
    );
  }

  truckDetailsEdit() {
    this.TruckDetailsBtn = true;
    this.panel1form1 = true;
    this.panel2 = false;
    this.panel2form1 = false;
    this.panel3 = false;
    this.panel3form1 = false;
    this.selectedTruck = false;
    this.loadDetailsBtn = false;
    this.terms = false;
    this.bookingDetailBtn = false;
    this.loadDetailsBtn = false;
    this.paymentBtn = false;
  }

  onTruckSelected(item: any, index: any) {
    this.token = sessionStorage.getItem("token");
    if (!this.token) {
      this.loginModal();
      return;
    }
    this.selectedIndexValue = item;
    this.selectedTruck = true;
    this.selectedTruckDetails = item;
    this.selectedTruckDetailsIndex = index;
    if (this.token) {
      let data: any = {
        driver_ref_id: this.selectedTruckDetails.driver_ref_id,
        fromLocation: {
          from_area_name: this.selectedTruckDetails.fromLocation.from_area_name,
          from_city_name: this.pickup_short_name,
          from_lat: (Math.round(this.pickupLat * 10000) / 10000).toString(), //this.numberWith4Decimal(this.pickupLat),
          from_long: (Math.round(this.pickupLong * 10000) / 10000).toString(), //this.numberWith4Decimal(this.pickupLong),
          from_pincode: Number(this.pickup_postal_code) || 0,
        },
        from_complete_address: this.completePickUpAddress?.formatted_address || "",
        to_complete_address: this.completeDropAddress?.formatted_address || "",
        toLocation: {
          to_area_name: this.drop_long_name,
          to_city_name: this.drop_short_name,
          to_lat: (Math.round(this.dropLat * 10000) / 10000).toString(), //this.numberWith4Decimal(this.dropLat),
          to_long: (Math.round(this.dropLong * 10000) / 10000).toString(), //this.numberWith4Decimal(this.dropLong),  // this.SearchTruckDetails.toLocation.to_long,
          to_pincode: Number(this.dropoff_postal_code) || 0,
        },
        date: formatDate(this.coordinatesForm.value.date, "yyyy-MM-dd", "en"),
        truck_category: this.coordinatesForm.value.truck_category_name,
        truck_type: this.coordinatesForm.value.truck_weight,
        dro_id: this.selectedTruckDetails._id,
      };
      this.GetTripBookingId(data);
    }
  }
  onQuoteTruckSelected(item: any, index: any) {
    this.token = sessionStorage.getItem("token");
    if (!this.token) {
      this.loginModal();
      return;
    }
    this.alternateIndexValue = item;
    this.alternateSelectedTruck = true;
    this.alternateTruckDetails = item;
    this.selectedTruckDetails = item;
    if (this.SearchTruckDetails?.truckweight) {
      this.SearchTruckDetails.truckweight.truck_weight = "";
    }
    if (this.SearchTruckDetails) {
      this.SearchTruckDetails.date = "";
    }
    this.alternateSelectedTruckDetailsIndex = index;
    if (this.token) {
      let data: any = {
        fromLocation: {
          from_area_name: this.alternateTruckDetails.fromLocation.from_area_name,
          from_city_name: this.pickup_short_name,
          from_lat: (Math.round(this.pickupLat * 10000) / 10000).toString(), //this.numberWith4Decimal(this.pickupLat),
          from_long: (Math.round(this.pickupLong * 10000) / 10000).toString(), //this.numberWith4Decimal(this.pickupLong),
          from_pincode: Number(this.pickup_postal_code) || 0,
        },
        from_complete_address: this.completePickUpAddress?.formatted_address || "",
        to_complete_address: this.completeDropAddress?.formatted_address || "",
        toLocation: {
          to_area_name: this.drop_long_name,
          to_city_name: this.drop_short_name,
          to_lat: (Math.round(this.dropLat * 10000) / 10000).toString(), //this.numberWith4Decimal(this.dropLat),
          to_long: (Math.round(this.dropLong * 10000) / 10000).toString(), //this.numberWith4Decimal(this.dropLong),  // this.SearchTruckDetails.toLocation.to_long,
          to_pincode: Number(this.dropoff_postal_code) || 0,
        },
        date: formatDate(this.coordinatesForm.value.date, "yyyy-MM-dd", "en"),
        truck_category: this.coordinatesForm.value.truck_category_name,
        truck_type: this.coordinatesForm.value.truck_weight,
        driver_ref_id: this.alternateTruckDetails?.driver_ref_id,
        dro_id: this.alternateTruckDetails._id,
      };

      this.GetTripBookingId(data);
    }
  }

  public loadCatChange(category: any, index: any) {
    this.materialDetails = "";

    this.loadSelectedCategory = category;
    this.loadCategorySelectedindex = index;
    this.materialDetails = this.loadCategory.find((ele: any) => {
      return ele.load_category === category;
    });
  }

  loginModal() {
    const dialogRef = this.matDialog.open(LoginComponent, {
      width: "500px",
      data: {
        routeFrom: "TruckDetails",
        tripSearchData: this.SearchTruckDetails,
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.token = sessionStorage.getItem("token");
      if (this.token) {
        if (this.selectedTruck && this.selectedTruckDetails) {
          this.onTruckSelected(this.selectedTruckDetails, this.selectedTruckDetailsIndex);
        } else if (this.alternateSelectedTruck && this.alternateTruckDetails) {
          this.onQuoteTruckSelected(this.alternateTruckDetails, this.alternateSelectedTruckDetailsIndex);
        }
        this.HandlePayments();
      }
    });
  }

  HandlePayments() {
    this.token = sessionStorage.getItem("token");
    if (!this.token) {
      this.loginModal();
      return;
    }
    const driver_ref_id = this.selectedTruckDetails?.driver_ref_id || this.QuoteTruckDetails?.driver_ref_id || this.alternateTruckDetails?.driver_ref_id;
    if (!driver_ref_id) {
      this.snackBar.open("Driver ID missing. Cannot proceed to payments.", "Fail", {
        duration: 5000,
      });
      return;
    }

    this.GoToPayments();
  }

  GoToPayments() {
    // In new flow, Material selection happened BEFORE sending truck search.
    // So this check is just a safeguard.
    if (
      this.loadSelectedCategory === "" ||
      this.billingForm.value.material === ""
    ) {
      this.snackBar.open("Please select material", "Fail", {
        duration: 5000,
      });
      return;
    }
    // Switch to Billing Pane (panel3)
    this.TruckDetailsBtn = false;
    this.loadDetailsBtn = false;

    this.panel1form1 = false; // Collapse Truck
    this.downImg1 = false;
    this.checkImg1 = true;

    this.panel3 = true;
    this.panel3form1 = true;

    this.selecteLoadCategory = true;
    this.paymentBtn = true;
    this.terms = true;
    this.getProfileDetails();
    this.GetTaxDetails();
  }

  GetTaxDetails() {
    this.tax_details = []; // reset previous tax details
    if (this.Quotation == true) {
      this.price = this.alternateTruckDetails?.price;
    } else if (this.loadDetails == "quoteBooked") {
      this.price = this.QuoteTruckDetails?.driver_route_info[0]?.price;
      this.selectedHSNCode = this.QuoteTruckDetails?.hsn_code;
    } else {
      this.price = this.selectedTruckDetails.price;
    }
    this.totalAmount = this.price;
    this.round_amount = this.totalAmount;
    this.services.GetTaxdetails(this.selectedHSNCode).subscribe(
      (response: any) => {
        this.paymentDetails = response.body.data;
        for (let i = 0; i < this.paymentDetails.length; i++) {
          let taxObj: any = {
            tax_name: this.paymentDetails[i].tax_name,
            tax_type: this.paymentDetails[i].tax_type,
            tax_deduction: this.paymentDetails[i]?.tax_deduction,
          };
          // If fcm_deduction exists, override tax_deduction and add gst_mode
          if (this.paymentDetails[i]?.fcm_deduction !== undefined) {
            taxObj.tax_deduction = this.paymentDetails[i].fcm_deduction;
            taxObj.gst_mode = "fcm";
          }
          this.tax_details.push(taxObj);
          const tax = this.paymentDetails[i];
          const deduction =
            tax.tax_deduction !== undefined
              ? Number(tax.tax_deduction)
              : tax.fcm_deduction !== undefined
                ? Number(tax.fcm_deduction)
                : 0;
          if (tax.tax_type === "percent") {
            this.totalAmount += (this.price * deduction) / 100;
          } else {
            this.totalAmount += deduction;
          }
        }
        this.round_amount = Math.round(this.totalAmount);
        this.paynowAmt = this.totalAmount * 0.1;
        this.round_payamount = Math.round(this.paynowAmt);
      },
      (error: any) => {
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });

        if (error.status != 404) {
          localStorage.clear();
          this.router.navigateByUrl("/");
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        return;
      }
    );
  }

  BillingEdit() {
    this.billingEdit = true;
    this.editBilling = false;
    this.isGstVerified =
      this.profileDetails?.gst_verified === true ||
      this.profileDetails?.gst_verified === 1 ||
      this.profileValues?.gst_verified === true ||
      this.profileValues?.gst_verified === 1;
  }

  onGstChange(): void {
    const enteredGst = (this.billingForm.controls['gst']?.value || "").trim().toUpperCase();
    const savedGst = (this.profileDetails?.gst || "").trim().toUpperCase();
    if (enteredGst !== savedGst) {
      this.isGstVerified = false;
      this.gstVerificationData = null;
    } else {
      this.isGstVerified =
        this.profileDetails?.gst_verified === true ||
        this.profileDetails?.gst_verified === 1;
    }
  }

  verifyGST(rawGst?: any, callback?: () => void): void {
    const gstValue = typeof rawGst === "string" ? rawGst : this.billingForm.controls["gst"]?.value;
    if (!gstValue || typeof gstValue !== "string" || gstValue.trim() === "") {
      this.snackBar.open("Please enter a GSTIN to verify", "OK", {
        duration: 4000,
      });
      return;
    }

    const cleanGst = gstValue.replace(/[^A-Za-z0-9]/g, "").trim().toUpperCase();
    if (cleanGst.length !== 15) {
      this.snackBar.open("GSTIN must be exactly 15 alphanumeric characters", "OK", {
        duration: 4000,
      });
      return;
    }

    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (!gstRegex.test(cleanGst)) {
      this.snackBar.open("Please enter a valid 15-digit GST format (e.g. 36AAECS9130L1Z1)", "OK", {
        duration: 4000,
      });
      return;
    }

    this.token = this.token || sessionStorage.getItem("token") || localStorage.getItem("token") || "";
    this.isGstVerifying = true;
    this.services.verifyGST(cleanGst, this.token).subscribe({
      next: (response: any) => {
        this.isGstVerifying = false;
        let resData = response.body?.data || response.body;

        while (
          resData?.data &&
          typeof resData.data === "object" &&
          !resData.lgnm &&
          !resData.tradeNam &&
          !Array.isArray(resData.data)
        ) {
          resData = resData.data;
        }

        if (
          response.body?.success === false ||
          response.body?.gst_verified === false ||
          resData?.error === true ||
          resData?.error === "true" ||
          resData?.code === "400" ||
          resData?.code === 5004 ||
          resData?.code === "5004"
        ) {
          const errMsg =
            response.body?.message ||
            (typeof resData?.data === "string" ? resData.data : "") ||
            resData?.message ||
            "Invalid or unverified GSTIN.";
          this.snackBar.open(errMsg, "Fail", { duration: 5000 });
          this.isGstVerified = false;
          return;
        }

        const taxpayerList = Array.isArray(resData?.data)
          ? resData.data
          : Array.isArray(resData)
          ? resData
          : null;
        const taxpayer = taxpayerList
          ? taxpayerList[0]
          : resData?.data || resData;

        if (
          !taxpayer ||
          (!taxpayer.lgnm && !taxpayer.tradeNam && !taxpayer.gstin)
        ) {
          this.snackBar.open("GST details not found for this GSTIN.", "Fail", {
            duration: 5000,
          });
          this.isGstVerified = false;
          return;
        }

        this.isGstVerified = true;
        this.gstVerificationData = taxpayer;
        this.billingForm.controls['gst'].setValue(cleanGst);

        // Autofill address details from Master India GST if not present
        if (taxpayer.pradr?.addr) {
          const addr = taxpayer.pradr.addr;
          const addressParts = [addr.bno, addr.flno, addr.bnm, addr.st, addr.loc]
            .map((p: any) => (p || "").trim())
            .filter((p: string) => p.length > 0);
          if (addressParts.length > 0 && !this.billingForm.controls['address_line']?.value) {
            this.billingForm.controls['address_line'].setValue(addressParts.join(", "));
          }
          const city = (addr.city || addr.dst || "").trim();
          if (city && !this.billingForm.controls['city']?.value) {
            this.billingForm.controls['city'].setValue(city);
          }
          const state = (addr.stcd || "").trim();
          if (state && !this.billingForm.controls['state']?.value) {
            this.billingForm.controls['state'].setValue(state);
          }
          const pincode = (addr.pncd || "").toString().trim();
          if (pincode && !this.billingForm.controls['pincode']?.value) {
            this.billingForm.controls['pincode'].setValue(pincode);
          }
        }

        const businessName = (taxpayer.tradeNam || taxpayer.lgnm || "").trim();
        const nameMsg = businessName ? ` (${businessName})` : "";
        this.snackBar.open(`GSTIN Verified Successfully${nameMsg}!`, "Success", {
          duration: 5000,
        });

        if (callback) {
          callback();
        }
      },
      error: (error: any) => {
        this.isGstVerifying = false;
        this.isGstVerified = false;
        const errObj = error.error;
        const errMsg =
          errObj?.message ||
          (typeof errObj?.data === "string" ? errObj.data : "") ||
          (typeof errObj?.data?.data === "string" ? errObj.data.data : "") ||
          errObj?.data?.message ||
          error.message ||
          "GST verification failed. Please try again.";
        this.snackBar.open(errMsg, "Fail", { duration: 5000 });
      },
    });
  }

  isValidGST(gst: string): boolean {
    if (!gst) return false;
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    return gstRegex.test(gst.toUpperCase());
  }

  updateBillingAddress() {
    const rawGst = (this.billingForm.value.gst || "").trim().toUpperCase();

    // If GST is provided and 15 chars, but not verified yet, verify it before saving
    if (this.billingEdit && rawGst && rawGst.length === 15 && !this.isGstVerified) {
      if (this.isGstVerifying) return;
      this.verifyGST(rawGst, () => {
        this.executeBillingAddressUpdate();
      });
      return;
    }

    this.executeBillingAddressUpdate();
  }

  executeBillingAddressUpdate() {
    const rawGst = this.billingEdit
      ? (this.billingForm.value.gst?.toUpperCase() || "").trim()
      : (this.profileDetails?.gst || "").trim();

    const billingAddress = {
      billing_address: {
        username: this.billingEdit
          ? this.billingForm.value.username || this.billingForm.value.name
          : this.profileDetails.username,
        state: this.billingEdit
          ? this.billingForm.value.state
          : this.profileDetails.state,
        address_line: this.billingEdit
          ? this.billingForm.value.address_line || this.billingForm.value.address
          : this.profileDetails.address_line,
        email: this.billingEdit
          ? this.billingForm.value.email
          : this.profileDetails.email,
        landmark: this.billingEdit ? "" : this.profileDetails.landmark,
        pincode: this.billingEdit
          ? this.billingForm.value.pincode
          : this.profileDetails.pincode,
        area_name: this.billingEdit ? "" : this.profileDetails.area_name,
        gst: rawGst,
        gst_verified: !!this.isGstVerified,
        mobile: this.billingEdit ? "" : this.profileDetails.mobile,
        city: this.billingEdit
          ? this.billingForm.value.city
          : this.profileDetails.city,
      },
    };
    this.services.UpdateProfile(billingAddress, this.token).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.getProfileDetails();
          this.editBilling = true;
          this.billingEdit = false;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  GoToEditBilling() {
    this.loadDetailsBtn = true;
    this.panel2form1 = true;
    this.panel3 = false;
    this.panel3form1 = false;
    this.TruckDetailsBtn = false;
    this.selecteLoadCategory = false;
    this.paymentBtn = false;
    this.panel3 = false;
    this.terms = false;
  }
  editBookingDetails() {
    this.panel = true;
    this.panelForm = true;
    this.paymentBtn = false;
    this.TruckDetailsBtn = false;
    this.loadDetailsBtn = false;
    this.bookingDetailBtn = true;
    this.panel3 = false;
    this.panel3form1 = false;
    this.panel2form1 = false;
    this.panel2 = false;
    this.panel1 = false;
    this.panel1form1 = false;
    this.terms = false;
  }
  cancel() {
    this.matDialogref = this.matDialog.open(CancellationPolicyComponent, {
      width: "972px",
      maxHeight: "68vh",
      autoFocus: false,
    });
  }

  getProfileDetails() {
    this.token = this.token || sessionStorage.getItem("token") || localStorage.getItem("token") || "";
    this.services.GetProfile(this.token).subscribe(
      (response: any) => {
        this.profileValues = response.body.data;
        this.profileDetails = response.body.data.billing_address;
        this.isGstVerified =
          this.profileDetails?.gst_verified === true ||
          this.profileDetails?.gst_verified === 1 ||
          this.profileValues?.gst_verified === true ||
          this.profileValues?.gst_verified === 1;

        if (!this.profileDetails) {
          this.billingEdit = true;
          this.editBilling = false;
        } else {
          this.editBilling = true;
          this.billingForm.patchValue({
            username: this.profileDetails.username,
            name: this.profileDetails.username,
            address_line: this.profileDetails.address_line,
            address: this.profileDetails.address_line,
            city: this.profileDetails.city,
            state: this.profileDetails.state,
            pincode: this.profileDetails.pincode,
            gst: this.profileDetails.gst,
          });
        }
      },
      (error) => {
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        return;
      }
    );
  }

  onlinePayment(res: any, token: any, tripBookingResponse: any) {
    var options = {
      key: environment.razorpay_key,
      amount: Number(this.round_payamount) * 100,
      currency: "INR",
      name: "S9trucks",
      description: `1st payment is successful for trip id: ${tripBookingResponse?.body.data.trip_id}`,
      image:
        "https://s9trucks.s3.us-east-2.amazonaws.com/1660327946469%20-%20S9256.png",
      order_id: res.body.data.id,
      handler: (response: any) => {
        if (this.selectedTruck == true) {
          this.driver_route_id = this.selectedTruckDetails?._id;
        }
        if (this.alternateSelectedTruck == true) {
          this.driver_route_id = this.alternateTruckDetails?._id;
        }
        if (this.loadDetails == "quoteBooked") {
          this.driver_route_id =
            this.QuoteTruckDetails?.driver_route_info[0]?._id;
        }
        const payload = {
          success: {
            razorpay_payment_id: response.razorpay_payment_id,
            order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
          },
          paymentStatus: "partial-paid",
          driver_route_id: this.driver_route_id,
          driver_ref_id:
            this.selectedTruckDetails?.driver_ref_id ||
            this.alternateTruckDetails?.driver_ref_id,
        };
        this.services
          .updatePaymentResponse(token, payload, res.body.paymentInfo._id)
          .subscribe(
            (payResponse: any) => {
              this.snackBar.open(payResponse.body.message, "Success", {
                duration: 5000,
              });
              this.commonServices.publishMessage(
                "tripAssigned",
                tripBookingResponse.body.data
              );

              sessionStorage.removeItem("quoteBooked");
              this.router.navigate(["/trips"]);
              this.loading = false;
            },
            (error: any) => {
              this.snackBar.open(error.error.message, "Fail", {
                duration: 5000,
              });
              if (error.error.message === "jwt expired") {
                this.router.navigateByUrl("/");
                localStorage.clear();
              }
              if (error.error.message === "jwt malformed") {
                this.router.navigateByUrl("/");
                localStorage.clear();
              }
              return;
            }
          );
      },
      prefill: {
        name: this.profileValues.username,
        email: this.profileValues.email ? this.profileValues.email : "",
        contact: this.profileValues.mobile,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#f25510",
      },
    };
    var rzp1 = new this.windowRef.nativeWindow.Razorpay(options);
    rzp1.open();
    rzp1.on("payment.failed", (errorResponse: any) => {
      const payload = {
        failure: {
          code: errorResponse.error.code,
          description: errorResponse.error.description,
          reason: errorResponse.error.reason,
          order_id: errorResponse.error.metadata.order_id,
          razorpay_payment_id: errorResponse.error.metadata.payment_id,
        },
        paymentStatus: "failed",
      };
      rzp1.close();
      this.router.navigate(["/trips"]);
    });
  }

  tripBooking() {
    this.loading = true;
    const driver_ref_id = this.selectedTruckDetails?.driver_ref_id || this.QuoteTruckDetails?.driver_ref_id || this.alternateTruckDetails?.driver_ref_id;
    const currentFare = this.selectedTruckDetails?.price || this.QuoteTruckDetails?.driver_route_info[0]?.price || this.alternateTruckDetails?.price;
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.snackBar.open('Authentication token missing. Please log in again.', '', {
        duration: 3000,
      });
      this.loading = false;
      return;
    }

    if (!driver_ref_id || currentFare == null) {
      this.snackBar.open('Incomplete truck details. Please try again.', '', {
        duration: 3000,
      });
      this.loading = false;
      return;
    }
    this.continueBooking();
  }

  stopContactDetails() {
    if (!this.QuoteTruckDetails?.stops) return;
    this.QuoteTruckDetails.stops.forEach((stop: any, i: number) => {
      this.billingForm.addControl(
        `stop_contact_name_${i}`,
        new FormControl("", Validators.required)
      );
      this.billingForm.addControl(
        `stop_contact_number_${i}`,
        new FormControl("", [Validators.required, Validators.pattern("^[0-9]{10}$")])
      );
      this.billingForm.addControl(
        `stop_category_${i}`,
        new FormControl(null, Validators.required)
      );
    });
  }

  public continueBooking() {
    const characterRegex = /^[a-zA-Z][a-zA-Z\\s]+$/;
    const numericRegex = /^[0-9]{10}$/;
    const pincodeRegex = /^\d{6}$/;
    this.loading = true;
    if (this.billingEdit === true) {
      this.loading = true;
      if (
        this.billingForm.value.name === "" ||
        !characterRegex.test(this.billingForm.value.name)
      ) {
        this.snackBar.open("Please enter correct name", "Fail", {
          duration: 5000,
        });
        this.loading = false;
        return;
      }
      if (this.billingForm.value.address_line === "") {
        this.snackBar.open("Please enter address", "Fail", {
          duration: 5000,
        });
        this.loading = false;
        return;
      }
      if (
        this.billingForm.value.city === "" ||
        !characterRegex.test(this.billingForm.value.city)
      ) {
        this.snackBar.open("Please enter correct city", "Fail", {
          duration: 5000,
        });
        this.loading = false;
        return;
      }
      if (
        this.billingForm.value.state === "" ||
        !characterRegex.test(this.billingForm.value.state)
      ) {
        this.snackBar.open("Please enter state", "Fail", {
          duration: 5000,
        });
        this.loading = false;
        return;
      }
      if (
        this.billingForm.value.pincode === "" ||
        !pincodeRegex.test(this.billingForm.value.pincode)
      ) {
        this.snackBar.open("Please enter correct pincode", "Fail", {
          duration: 5000,
        });
        this.loading = false;
        return;
      }
    }
    if (this.billingForm.value.pickupContact === "") {
      this.snackBar.open("Please enter correct pickup name", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    if (
      this.billingForm.value.pickupMobile === "" ||
      !numericRegex.test(this.billingForm.value.pickupMobile)
    ) {
      this.snackBar.open("Please enter a valid 10-digit pickup contact number", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    if (this.billingForm.value.dropupContact === "") {
      this.snackBar.open("Please enter correct dropoff name", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    if (
      this.billingForm.value.dropupMobile === "" ||
      !numericRegex.test(this.billingForm.value.dropupMobile)
    ) {
      this.snackBar.open("Please enter a valid 10-digit dropoff contact number", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }

    if (this.QuoteTruckDetails?.stops && this.QuoteTruckDetails.stops.length > 0) {
      for (let i = 0; i < this.QuoteTruckDetails.stops.length; i++) {
        const stopName = this.billingForm.get(`stop_contact_name_${i}`)?.value;
        const stopNumber = this.billingForm.get(`stop_contact_number_${i}`)?.value;
        const stopCategory = this.billingForm.get(`stop_category_${i}`)?.value;

        if (!stopName) {
          this.snackBar.open(`Please enter contact name for Stop ${i + 1}`, "Fail", {
            duration: 5000,
          });
          this.loading = false;
          return;
        }
        if (!stopNumber || !numericRegex.test(stopNumber)) {
          this.snackBar.open(
            `Please enter a valid 10-digit contact number for Stop ${i + 1}`,
            "Fail",
            { duration: 5000 }
          );
          this.loading = false;
          return;
        }
        if (!stopCategory) {
          this.snackBar.open(`Please select category for Stop ${i + 1}`, "Fail", {
            duration: 5000,
          });
          this.loading = false;
          return;
        }
      }
    }
    if (this.billingForm.value.check1 !== true) {
      this.snackBar.open("Please check the balance amount", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    if (!this.terms_check) {
      this.snackBar.open("Please check the terms and conditions", "Fail", {
        duration: 5000,
      });
      this.loading = false;
      return;
    }
    if (this.billingForm.value.insurance_acknowledgement !== true) {
      this.snackBar.open(
        "Please acknowledge the insurance responsibility",
        "Fail",
        { duration: 5000 }
      );
      this.loading = false;
      return;
    }
    var token = sessionStorage.getItem("token");
    sessionStorage.removeItem("quotes");
    if (this.selectedTruck == true) {
      this.driver_route_id = this.selectedTruckDetails?._id;
    }
    if (this.alternateSelectedTruck == true) {
      this.driver_route_id = this.alternateTruckDetails?._id;
    }
    if (this.loadDetails == "quoteBooked") {
      this.driver_route_id = this.QuoteTruckDetails?.driver_route_info[0]?._id;
    }
    const tripBookData: any = {
      driver_route_id: this.driver_route_id,
      driver_ref_id:
        this.selectedTruckDetails?.driver_ref_id || this.alternateTruckDetails?.driver_ref_id || this.QuoteTruckDetails?.driver_ref_id,
      // load_type: this.loadSelectedCategory,
      // material_type:
      //   this.billingForm.value.others !== ""
      //     ? this.billingForm.value.material +
      //     "-" +
      //     this.billingForm.value.others
      //     : this.billingForm.value.material,
      billing_address: {
        username: this.billingEdit
          ? this.billingForm.value.username || this.billingForm.value.name
          : this.profileDetails.username,
        state: this.billingEdit
          ? this.billingForm.value.state
          : this.profileDetails.state,
        address_line: this.billingEdit
          ? this.billingForm.value.address_line || this.billingForm.value.address
          : this.profileDetails.address_line,
        landmark: this.billingEdit ? "" : this.profileDetails.landmark,
        pincode: this.billingEdit
          ? this.billingForm.value.pincode
          : this.profileDetails.pincode,
        area_name: this.billingEdit ? "" : this.profileDetails.area_name,
        gst: this.billingEdit
          ? (this.billingForm.value.gst?.toUpperCase() || "")
          : (this.profileDetails?.gst || ""),
        gst_verified: !!this.isGstVerified,
        mobile: this.billingEdit ? "" : this.profileDetails.mobile,
        city: this.billingEdit
          ? this.billingForm.value.city
          : this.profileDetails.city,
      },
      pickup_name: this.billingForm.value.pickupContact,
      pickup_contact: this.billingForm.value.pickupMobile,
      dropoff_name: this.billingForm.value.dropupContact,
      dropoff_contact: this.billingForm.value.dropupMobile,
      terms_and_conditions: this.billingForm.value.terms_and_conditions,
      balance_before_trip_started: this.billingForm.value.check1,
      insurance_acknowledgement: this.billingForm.value.insurance_acknowledgement,
    };
    const stopsPayload: any[] = [];
    if (this.QuoteTruckDetails?.stops && this.QuoteTruckDetails.stops.length > 0) {
      this.QuoteTruckDetails.stops.forEach((stop: any, i: number) => {
        stopsPayload.push({
          stop_contact_name: this.billingForm.get(`stop_contact_name_${i}`)?.value || "",
          stop_contact_number: this.billingForm.get(`stop_contact_number_${i}`)?.value || "",
          stop_category: this.billingForm.get(`stop_category_${i}`)?.value || null
        });
      });
    }
    tripBookData["stops"] = stopsPayload;

    const billingAddress = {
      billing_address: {
        username: this.billingEdit
          ? this.billingForm.value.username || this.billingForm.value.name
          : this.profileDetails.username,
        state: this.billingEdit
          ? this.billingForm.value.state
          : this.profileDetails.state,
        address_line: this.billingEdit
          ? this.billingForm.value.address_line || this.billingForm.value.address
          : this.profileDetails.address_line,
        landmark: this.billingEdit ? "" : this.profileDetails.landmark,
        pincode: this.billingEdit
          ? this.billingForm.value.pincode
          : this.profileDetails.pincode,
        area_name: this.billingEdit ? "" : this.profileDetails.area_name,
        gst: this.billingEdit
          ? (this.billingForm.value.gst?.toUpperCase() || "")
          : (this.profileDetails?.gst || ""),
        gst_verified: !!this.isGstVerified,
        mobile: this.billingEdit ? "" : this.profileDetails.mobile,
        city: this.billingEdit
          ? this.billingForm.value.city
          : this.profileDetails.city,
      },
    };

    if (this.selectedTruck) {
      this.selected_Actual_Price = this.selectedTruckDetails?.price;
    }

    if (this.alternateSelectedTruck) {
      this.selected_Actual_Price = this.alternateTruckDetails?.price;
    }

    if (this.loadDetails === "quoteBooked") {
      this.tripId = "";
      this.selected_Actual_Price =
        this.QuoteTruckDetails?.driver_route_info[0]?.price;
      this.alternateTrip_Id = this.QuoteTruckDetails._id;
    } else {
      this.alternateTrip_Id = this.tripId;
    }

    this.services
      .UpdateProfile(billingAddress, token)
      .subscribe((response: any) => { });

    // console.log("this.selectedTruckDetails?.driver_ref_id || this.QuoteTruckDetails?.driver_ref_id ||this.QuoteTruckDetails?.driver_ref_id ,",this.QuoteTruckDetails?.driver_ref_id )
    // check tthis 
    this.services
      .TripBooking(tripBookData, token, this.alternateTrip_Id)
      .subscribe(
        (response: any) => {
          if (response.status === 201) {
            const paymentData = {
              price_details: {
                actual_price: this.selected_Actual_Price,
                total_amount: this.round_amount,
                amount_paid: this.round_payamount,
                tax_details: this.tax_details,
              },
              driver_ref_id: this.selectedTruckDetails?.driver_ref_id || this.QuoteTruckDetails?.driver_ref_id,
              driver_route_id: this.driver_route_id
            };

            this.downImg3 = false;
            this.checkImg3 = true;

            this.services
              .TripPayment(paymentData, response.body.data._id, token)
              .subscribe((res: any) => {
                this.onlinePayment(res, token, response);
              });
          }
        },
        (error) => {
          this.loading = false;
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
          if (
            error.error.message === "jwt expired" ||
            error.error.message === "jwt malformed" ||
            error.error.message === "This driver is already booked for another trip."
          ) {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
        }
      );
  }

  onInputPickUpchange() {
    this.geoCodePickUp(this.coordinatesForm.value.pickup);
    this.checkLocations();
  }

  onDropChange() {
    this.geoCodeDrop(this.coordinatesForm.value.drop);
    this.checkLocations();
  }
  checkLocations() {
    const pickups = this.coordinatesForm.get("pickup")?.value;
    const dropup = this.coordinatesForm.get("drop")?.value;
    if (pickups && dropup && pickups === dropup) {
      return;
    }
  }

  geoCodePickUp(address: any) {
    google.maps.event.addListener(
      this.pickupAutoComplete,
      "place_changed",
      () => {
        const place = this.pickupAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        geoCoder.geocode(
          {
            address: place.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.pickupLat = results[0].geometry.location.lat();
              this.pickupLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.pickupLat,
                this.pickupLong
              );
              this.autoCompletePickupGeoCode(geoCoder, latlong);

              this.coordinatesForm.controls["from_area_name"].setValue(
                place.formatted_address
              );
              this.checkLocations();
            }
          }
        );
      }
    );
  }

  autoCompletePickupGeoCode(geoCoder: any, latlong: any) {
    geoCoder.geocode({ location: latlong }, (result: any, status: any) => {
      if (status === google.maps.GeocoderStatus.OK && result && result.length > 0) {
        this.completePickUpAddress = result[0];
        for (
          let i = 0;
          i < this.completePickUpAddress.address_components.length;
          i++
        ) {
          if (
            this.completePickUpAddress.address_components[i].types[0] ==
            "locality" &&
            this.completePickUpAddress.address_components[i].types[1] ==
            "political"
          ) {
          }
          if (
            this.completePickUpAddress.address_components[i].types[0] ==
            "political" &&
            this.completePickUpAddress.address_components[i].types[1] ==
            "sublocality" &&
            this.completePickUpAddress.address_components[i].types[2] ==
            "sublocality_level_1"
          ) {
            this.pickup_long_name =
              this.completePickUpAddress.address_components[i].long_name;
          }
          if (
            this.completePickUpAddress.address_components[i].types[0] ==
            "postal_code"
          ) {
          }
          if (this.pickup_short_name && this.pickup_long_name) {
          }
        }
      }
    });
  }

  geoCodeDrop(address: any) {
    google.maps.event.addListener(
      this.dropAutoComplete,
      "place_changed",
      () => {
        const dropPlace = this.dropAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        geoCoder.geocode(
          {
            address: dropPlace.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.dropLat = results[0].geometry.location.lat();
              this.dropLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.dropLat,
                this.dropLong
              );
              this.autoCompleteDropGeoCode(geoCoder, latlong);

              this.coordinatesForm.controls["to_area_name"].setValue(
                dropPlace.formatted_address
              );
              this.checkLocations();
            }
          }
        );
      }
    );
  }

  autoCompleteDropGeoCode(geoCoder: any, latlong: any) {
    geoCoder.geocode({ location: latlong }, (result: any, status: any) => {
      if (status === google.maps.GeocoderStatus.OK && result && result.length > 0) {
        this.completeDropAddress = result[0];
        for (
          let i = 0;
          i < this.completeDropAddress.address_components.length;
          i++
        ) {
          if (
            this.completeDropAddress.address_components[i].types[0] ==
            "locality" &&
            this.completeDropAddress.address_components[i].types[1] == "political"
          ) {
            this.drop_short_name =
              this.completeDropAddress.address_components[i].long_name;
          }
          if (
            this.completeDropAddress.address_components[i].types[0] ==
            "political" &&
            this.completeDropAddress.address_components[i].types[1] ==
            "sublocality" &&
            this.completeDropAddress.address_components[i].types[2] ==
            "sublocality_level_1"
          ) {
          }
          if (
            this.completeDropAddress.address_components[i].types[0] ==
            "postal_code"
          ) {
          }
        }
      }
    });
  }

  public GetCategory() {
    this.services.GetCategory().subscribe(
      (response: any) => {
        if (response.status === 200) {
          // Sorting the truck categories alphabetically by truck_category_name
          this.truckCategory = response.body.data
            .filter((item: any) => item.truck_category_name) // Ensures no undefined values
            .sort((a: any, b: any) =>
              a.truck_category_name.localeCompare(b.truck_category_name)
            );
          if (this.SearchTruckDetails?.truck_category) {
            const targetCat = this.SearchTruckDetails.truck_category;
            const matchedCat = this.truckCategory.find(
              (c: any) =>
                c._id === targetCat ||
                c.truck_category_name?.toLowerCase() ===
                targetCat?.toString().toLowerCase()
            );
            if (matchedCat) {
              this.coordinatesForm.controls["truck_category_name"].setValue(matchedCat._id);
              this.GetTruckWeight();
            }
          }
        }
      },
      (error) => {
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        return;
      }
    );
  }

  public GetTruckWeight() {
    var category = this.coordinatesForm.value.truck_category_name
      ? this.coordinatesForm.value.truck_category_name
      : this.coordinatesForm.value.truck_category
        ? this.coordinatesForm.value.truck_category
        : this.SearchTruckDetails?.truck_category;
    if (!category) {
      this.truckWeight = [];
      return;
    }
    this.services.GettruckWeight(category).subscribe(
      (response: any) => {
        if (response.status === 200) {
          // Sorting truck weights numerically
          this.truckWeight = (response.body.data || []).sort((a: any, b: any) => {
            let weightA = parseInt(a.truck_weight); // Extracting numeric value
            let weightB = parseInt(b.truck_weight);
            return weightA - weightB;
          });
          const targetWeight =
            this.SearchTruckDetails?.truck_type ||
            this.SearchTruckDetails?.truckweight?._id ||
            this.SearchTruckDetails?.truckweight?.truck_weight;
          if (targetWeight) {
            const matchedWeight = this.truckWeight.find(
              (w: any) =>
                w._id === targetWeight ||
                w.truck_weight?.toString().trim().toLowerCase() ===
                targetWeight.toString().trim().toLowerCase()
            );
            if (matchedWeight) {
              this.coordinatesForm.controls["truck_weight"].setValue(matchedWeight._id);
            }
          }
        }
      },
      (error) => {
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        return;
      }
    );
  }

  ngAfterViewInit(): void {
    var options = {
      componentRestrictions: { country: "in" },
    };
    const geoCoder = new google.maps.Geocoder();
    this.mapHtml = document.getElementById("map");
    this.mapOptions = {
      zoom: 8,
      center: new google.maps.LatLng(18.5204, 73.8567),
      disableDefaultUI: false,
      scrollWheel: true,
      draggable: true,
    };
    this.mapGoogle = new google.maps.Map(
      this.mapHtml as HTMLElement,
      this.mapOptions
    );
    this.directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer({
      draggable: true,
      map: this.mapGoogle,
    });
    this.directionsRenderer.set(this.mapGoogle);
    this.directionsRenderer.addListener("directions_changed", () => {
      const directions = this.directionsRenderer.getDirections();
      const directionChanged = directions?.routes[0].legs[0];
      geoCoder.geocode(
        {
          address: directionChanged?.start_address,
        },
        (results: any, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
            const latlong = new google.maps.LatLng(
              this.pickupLat,
              this.pickupLong
            );
            this.autoCompletePickupGeoCode(geoCoder, latlong);
          }
        }
      );
      geoCoder.geocode(
        {
          address: directionChanged?.end_address,
        },
        (results: any, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
            const latlong = new google.maps.LatLng(this.dropLat, this.dropLong);
            this.autoCompleteDropGeoCode(geoCoder, latlong);
          }
        }
      );
    });
    this.pickupAutoComplete = new google.maps.places.Autocomplete(
      this.pickUpLocation.nativeElement,
      options
    );
    this.dropAutoComplete = new google.maps.places.Autocomplete(
      this.dropLocation.nativeElement,
      options
    );
    this.pickupAddListener(geoCoder);
    this.dropAddListener(geoCoder);
    this.autoCoordinates(this.directionsService, this.directionsRenderer);

    if (this.pickupLat && this.pickupLong) {
      geoCoder.geocode({ location: { lat: +this.pickupLat, lng: +this.pickupLong } }, (results: any, status: any) => {
        if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
          const place = results[0];
          this.pickupPlace = place;
          this.completePickUpAddress = place;
          if (this.SearchTruckDetails) {
            this.SearchTruckDetails.pickupPlace = place;
            this.SearchTruckDetails.completePickUpAddress = place;
          }
          if (this.googleAddress) {
            this.googleAddress.completePickUpAddress = place;
          }
          this.coordinatesForm.controls["from_area_name"].setValue(place.formatted_address);
        }
      });
    }

    if (this.dropLat && this.dropLong) {
      geoCoder.geocode({ location: { lat: +this.dropLat, lng: +this.dropLong } }, (results: any, status: any) => {
        if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
          const dropPlace = results[0];
          this.dropPlace = dropPlace;
          this.completeDropAddress = dropPlace;
          if (this.SearchTruckDetails) {
            this.SearchTruckDetails.dropPlace = dropPlace;
            this.SearchTruckDetails.completeDropAddress = dropPlace;
          }
          if (this.googleAddress) {
            this.googleAddress.completeDropAddress = dropPlace;
          }
          this.coordinatesForm.controls["to_area_name"].setValue(dropPlace.formatted_address);
        }
      });
    }
  }

  pickupAddListener(geoCoder: any) {
    google.maps.event.addListener(
      this.pickupAutoComplete,
      "place_changed",
      () => {
        const place = this.pickupAutoComplete.getPlace();
        this.pickupPlace = place;
        this.completePickUpAddress = place;
        if (this.SearchTruckDetails) {
          this.SearchTruckDetails.pickupPlace = place;
          this.SearchTruckDetails.completePickUpAddress = place;
          if (this.SearchTruckDetails.fromLocation) {
            this.SearchTruckDetails.fromLocation.from_area_name = place.name;
            this.SearchTruckDetails.fromLocation.from_city_name = place.name;
          }
        }
        if (this.googleAddress) {
          this.googleAddress.completePickUpAddress = place;
        }

        // Update the Angular form control so it doesn't revert the input value
        this.coordinatesForm.controls["from_area_name"].setValue(
          place.formatted_address || place.name
        );

        this.directionsService
          .route({
            origin: place.formatted_address as HTMLInputElement,
            destination: this.googleAddress?.completeDropAddress
              ?.formatted_address as HTMLInputElement,
            optimizeWaypoints: true,
            travelMode: google.maps.TravelMode.DRIVING,
          })
          .then((response: google.maps.DirectionsResult) => {
            this.directionsRenderer.setDirections(response);
            this.directionsRenderer.setMap(this.mapGoogle);
          });
        geoCoder.geocode(
          {
            address: place.formatted_address,
          },
          (results: any, status: any) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.pickupLat = results[0].geometry.location.lat();
              this.pickupLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.pickupLat,
                this.pickupLong
              );
              this.autoCompletePickupGeoCode(geoCoder, latlong);
            }
          }
        );
      }
    );
  }

  dropAddListener(geoCoder: any) {
    google.maps.event.addListener(
      this.dropAutoComplete,
      "place_changed",
      () => {
        const dropPlace = this.dropAutoComplete.getPlace();
        this.dropPlace = dropPlace;
        this.completeDropAddress = dropPlace;
        if (this.SearchTruckDetails) {
          this.SearchTruckDetails.dropPlace = dropPlace;
          this.SearchTruckDetails.completeDropAddress = dropPlace;
          if (this.SearchTruckDetails.toLocation) {
            this.SearchTruckDetails.toLocation.to_area_name = dropPlace.name;
            this.SearchTruckDetails.toLocation.to_city_name = dropPlace.name;
          }
        }
        if (this.googleAddress) {
          this.googleAddress.completeDropAddress = dropPlace;
        }

        // Update the Angular form control so it doesn't revert the input value
        this.coordinatesForm.controls["to_area_name"].setValue(
          dropPlace.formatted_address || dropPlace.name
        );

        const geoCoder = new google.maps.Geocoder();
        this.directionsService
          .route({
            origin: this.googleAddress?.completePickUpAddress
              ?.formatted_address as HTMLInputElement,
            destination: dropPlace.formatted_address as HTMLInputElement,
            optimizeWaypoints: true,
            travelMode: google.maps.TravelMode.DRIVING,
          })
          .then((response: google.maps.DirectionsResult) => {
            this.directionsRenderer.setDirections(response);
            this.directionsRenderer.setMap(this.mapGoogle);
          });
        geoCoder.geocode(
          {
            address: dropPlace.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.dropLat = results[0].geometry.location.lat();
              this.dropLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.dropLat,
                this.dropLong
              );
              this.autoCompleteDropGeoCode(geoCoder, latlong);
            }
          }
        );
      }
    );
  }

  autoCoordinates(directionsService: any, directionsRenderer: any) {
    this.googleAddress = this.SearchTruckDetails;
    this.directionService(directionsService, directionsRenderer);
  }

  directionService(directionsService: any, directionsRenderer: any) {
    const waypoints: any[] = [];
    if (this.stopsArray && this.stopsArray.length > 0) {
      this.stopsArray.controls.forEach((stopCtrl: any) => {
        const stop = stopCtrl.value;
        if (stop.lat && stop.lng) {
          waypoints.push({
            location: new google.maps.LatLng(+stop.lat, +stop.lng),
            stopover: true,
          });
        }
      });
    }
    // Request route from Google Directions API
    directionsService
      .route({
        origin: this.googleAddress?.completePickUpAddress?.formatted_address as HTMLInputElement,
        destination: this.googleAddress?.completeDropAddress?.formatted_address as HTMLInputElement,
        waypoints: waypoints, // Include your stops here
        optimizeWaypoints: false, // keep stop order same as input
        travelMode: google.maps.TravelMode.DRIVING,
      })
      .then((response: google.maps.DirectionsResult) => {
        directionsRenderer.setDirections(response);
        directionsRenderer.setMap(this.mapGoogle);
      });

    // keep existing helper functions
    this.setPickupValuesInForm();
    this.setDropAddressInForm();
  }


  setPickupValuesInForm() {
    if (!this.googleAddress?.completePickUpAddress?.address_components) return;
    for (
      let i = 0;
      i < this.googleAddress.completePickUpAddress.address_components.length;
      i++
    ) {
      if (
        this.googleAddress?.completePickUpAddress.address_components[i]
          .types[0] == "locality" &&
        this.googleAddress?.completePickUpAddress.address_components[i]
          .types[1] == "political"
      ) {
        this.pickup_short_name =
          this.googleAddress?.completePickUpAddress.address_components[
            i
          ].long_name;
      }
      if (
        this.googleAddress?.completePickUpAddress.address_components[i]
          .types[0] == "political" &&
        this.googleAddress?.completePickUpAddress.address_components[i]
          .types[1] == "sublocality" &&
        this.googleAddress?.completePickUpAddress.address_components[i]
          .types[2] == "sublocality_level_1"
      ) {
        this.pickup_long_name =
          this.googleAddress?.completePickUpAddress.address_components[
            i
          ].long_name;
      }
      if (
        this.googleAddress?.completePickUpAddress.address_components[i]
          .types[0] == "postal_code"
      ) {
        this.pickup_postal_code = Number(
          this.googleAddress?.completePickUpAddress.address_components[i]
            .long_name
        );
      }
      // if (this.pickup_short_name && this.pickup_long_name) {
      //   this.coordinatesForm.controls["from_area_name"].setValue(
      //     `${this.pickup_long_name},${this.pickup_short_name}`
      //   );
      // }
    }
  }

  setDropAddressInForm() {
    if (!this.googleAddress?.completeDropAddress?.address_components) return;
    for (
      let i = 0;
      i < this.googleAddress.completeDropAddress.address_components.length;
      i++
    ) {
      if (
        this.googleAddress?.completeDropAddress.address_components[i]
          .types[0] == "locality" &&
        this.googleAddress?.completeDropAddress.address_components[i]
          .types[1] == "political"
      ) {
        this.drop_short_name =
          this.googleAddress?.completeDropAddress.address_components[
            i
          ].long_name;
      }
      if (
        this.googleAddress?.completeDropAddress.address_components[i]
          .types[0] == "political" &&
        this.googleAddress?.completeDropAddress.address_components[i]
          .types[1] == "sublocality" &&
        this.googleAddress?.completeDropAddress.address_components[i]
          .types[2] == "sublocality_level_1"
      ) {
        this.drop_long_name =
          this.googleAddress?.completeDropAddress.address_components[
            i
          ].long_name;
      }
      if (
        this.googleAddress?.completeDropAddress.address_components[i]
          .types[0] == "postal_code"
      ) {
        this.googleAddress.dropoff_postal_code = Number(
          this.googleAddress?.completeDropAddress.address_components[i]
            .long_name
        );
      }
      // if (this.drop_short_name && this.drop_long_name) {
      //   this.coordinatesForm.controls["to_area_name"].setValue(
      //     `${this.drop_long_name},${this.drop_short_name}`
      //   );
      // }
    }
  }
  others(eve: any) {
    if (eve && eve.hsn_id) {
      this.selectedHSNCode = eve.hsn_code;
    }
    if (eve.name == "Others") {
      this.otherValue = eve.name;
      this.othersType = true;
    } else {
      this.othersType = false;
    }
  }
  getWebPages(selectedType: any) {
    window.open(`/webPages/${selectedType}`);
  }
  selectedTerms(event: any) {
    this.terms_check = event.checked;
  }
  findExactTrucks() {
    let data: any = {
      from_complete_address: this.completePickUpAddress.formatted_address,
      pickup_details: {
        from_area_name: this.SearchTruckDetails.fromLocation.from_area_name,
        from_city_name: this.pickup_short_name,
        from_lat: (Math.round(this.pickupLat * 10000) / 10000).toString(),
        from_long: (Math.round(this.pickupLong * 10000) / 10000).toString(),
        from_pincode: Number(this.pickup_postal_code) || 0,
      },
      to_complete_address: this.completeDropAddress.formatted_address,
      dropoff_details: {
        to_area_name: this.drop_long_name,
        to_city_name: this.drop_short_name,
        to_lat: (Math.round(this.dropLat * 10000) / 10000).toString(),
        to_long: (Math.round(this.dropLong * 10000) / 10000).toString(),
        to_pincode: Number(this.dropoff_postal_code) || 0,
      },
      pickup_date: formatDate(
        this.coordinatesForm.value.date,
        "yyyy-MM-dd",
        "en"
      ),
      truck_category: this.coordinatesForm.value.truck_category_name,
      truck_type: this.coordinatesForm.value.truck_weight,
      trip_booking_map_url: "",
    };
    // model 
    this.matDialogre = this.matDialog.open(ModelComponent, {
      width: "600px",
      height: "auto",
      data: data,
      autoFocus: false,
    });
    this.matDialogre.afterClosed().subscribe((x) => { });
  }
  clearPickField() {
    this.coordinatesForm.get("from_area_name")?.setValue("");
    this.coordinatesForm.get("from_area_name")?.updateValueAndValidity();
    this.showCloseIconPick = false;
    this.pickup_long_name = "";
    this.pickup_short_name = "";
    this.pickup_postal_code = "";
    this.pickupLat = "";
    this.pickupLong = "";
    this.completePickUpAddress = null;
    this.pickupPlace = null;
    this.checkLocations();
  }
  clearDropField() {
    this.coordinatesForm.get("to_area_name")?.setValue("");
    this.coordinatesForm.get("to_area_name")?.updateValueAndValidity();
    this.showCloseIconDrop = false;
    this.drop_long_name = "";
    this.drop_short_name = "";
    this.dropoff_postal_code = "";
    this.dropLat = "";
    this.dropLong = "";
    this.completeDropAddress = null;
    this.dropPlace = null;
    this.checkLocations();
  }

  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }
}
